<section class="main-section dashboard-section">

  <div class="row align-items-end">
    <div class="col-10">
      <h2>Orders</h2>
    </div>
    <div class="col">
      <ng-select id="accountOwner" placeholder="Search/ Select User" [(ngModel)]="accountOwner" (change)="getList()"
                 [ngModelOptions]="{standalone: true}" required [items]="accountOwners" bindLabel="ownerName"
                 bindValue="id" [searchFn]="customSearchAccountOwner"
                 [searchWhileComposing]="true">
        <ng-template ng-option-tmp let-item="item">
          {{item?.ownerName}} <br/>
          <small>{{item?.companyName}}</small>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="row mb-4 deskContent">
    <div class="col-md mb-2 mb-md-0" style="position: relative;" (click)="navigateToOrder('submitted')">
      <div class="box">
        <h1 style="z-index: 1100;">{{orders?.submittedCount || 0}}
          <small>New</small>
        </h1>
<!--
        <div class="widget-graph">
          <canvas id="newOrderChart"></canvas>
        </div>
-->
      </div>
    </div>
    <div class="col-md mb-2 mb-md-0 " style="position: relative;" (click)="navigateToOrder('onHold')">
      <div class="box">
        <h1 style="z-index: 1100;">{{orders?.onHoldCount || 0}}
          <small>On Hold</small>
        </h1>
<!--
        <div class="widget-graph">
          <canvas id="readyToShipChart"></canvas>
        </div>
-->
      </div>
    </div>
    <div class="col-md mb-2 mb-md-0 " style="position: relative;" (click)="navigateToOrder('readyToShip')">
      <div class="box">
        <h1 style="z-index: 1100;">{{orders?.shippedCount || 0}}
          <small>Shipped </small>
        </h1>
<!--
        <div class="widget-graph">
          <canvas id="shippedOrderChart"></canvas>
        </div>
-->
      </div>
    </div>
    <div class="col-md  mb-2 mb-md-0" style="position: relative;" (click)="navigateToOrder('delivered')">
      <div class="box ">
        <h1 style="z-index: 1100;">{{orders?.deliveredCount || 0}}
          <small>Delivered (today)</small>
        </h1>
<!--
        <div class="widget-graph">
          <canvas id="deliveredChart"></canvas>
        </div>
-->
      </div>
    </div>
    <div class="col-md mb-2 mb-md-0 " style="position: relative;" (click)="navigateToOrder('exception')">
      <div class="box ">
        <h1 style="z-index: 1100;">{{orders?.exceptionCount || 0}}
          <small>With Exceptions</small>
        </h1>
<!--
        <div class="widget-graph">
          <canvas id="withExeChart"></canvas>
        </div>
-->
      </div>
    </div>
  </div>
  <div class="slide MobileContent">
    <div (click)="navigateToOrder('submitted')">
      <div class="box">
        <h1 style="z-index: 1100;">{{orders?.submittedCount || 0}}
          <small>New</small>
        </h1>
<!--
        <div class="widget-graph">
          <canvas id="newOrderChart"></canvas>
        </div>
-->

      </div>
    </div>
    <div (click)="navigateToOrder('onHold')">
      <div class="box">
        <h1 style="z-index: 1100;">{{orders?.onHoldCount || 0}}
          <small>On Hold</small>
        </h1>
<!--
        <div class="widget-graph">
          <canvas id="readyToShipChart"></canvas>
        </div>
-->
      </div>
    </div>
    <div (click)="navigateToOrder('readyToShip')">
      <div class="box">
        <h1 style="z-index: 1100;">{{orders?.shippedCount || 0}}
          <small>Shipped </small>
        </h1>
<!--
        <div class="widget-graph">
          <canvas id="shippedOrderChart"></canvas>
        </div>
-->
      </div>
    </div>
    <div (click)="navigateToOrder('delivered')">
      <div class="box ">
        <h1 style="z-index: 1100;">{{orders?.deliveredCount || 0}}
          <small>Delivered (today)</small>
        </h1>
<!--
        <div class="widget-graph">
          <canvas id="deliveredChart"></canvas>
        </div>
-->
      </div>
    </div>
    <div (click)="navigateToOrder('exception')">
      <div class="box ">
        <h1 style="z-index: 1100;">{{orders?.exceptionCount || 0}}
          <small>With Exceptions</small>
        </h1>
<!--
        <div class="widget-graph">
          <canvas id="withExeChart"></canvas>
        </div>
-->
      </div>
    </div>
  </div>

  <div class="row">
    <!--<div class="col-md-5 mb-4 ">
      <h2>Accounting</h2>
      <div class="row ">
        <div class="col ">
          <div class="box d-block " style="position: relative; " (click)="navigateToInvoice('paid')">
            <div class="row ">
              <div class="col ">
                <h1>{{invoice?.overDueCount||0}}
                  <small>Invoices Overdue</small>
                </h1>
              </div>
              <div class="col ">
                <h1 style="z-index: 1100; ">₹{{invoice?.overDueTotalAmount}}
                  <small>Amount</small>
                </h1>
              </div>
            </div>
            <div class="widget-graph w-25 " style="right: 0; ">
              <canvas id="invoiceChart"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2 ">
        <div class="col ">
          <div class="box d-block " style="position: relative; " (click)="navigateToInvoice('unPaid')">
            <div class="row ">
              <div class="col ">
                <h1>{{invoice?.unPaidCount||0}}
                  <small>Open Invoices</small>
                </h1>
              </div>
              <div class="col ">
                <h1 style="z-index: 1100; ">₹{{invoice?.unPaidTotalAmount||0}}
                  <small>Amount</small>
                </h1>
              </div>
            </div>
            <div class="widget-graph w-25 " style="right: 0; ">
              <canvas id="invoiceOpenChart"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>-->


    <div class="col-md-5 mb-4 ">
      <h2>Accounting</h2>
      <div class="row ">
        <div class="col ">
          <div class="box d-block " style="position: relative; " (click)="navigateToInvoice('paid')">
            <div class="row">
              <div class="col-8 col-sm-3">
                <h4 class="heading-bold">{{invoice?.invoicesOverdue || 0}}</h4>
                <p>Invoices Overdue</p>
              </div>
              <div class="col-4 col-sm-1 text-end">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="32" height="32" rx="4" fill="#2196F3" fill-opacity="0.08"/>
                  <path
                    d="M18.0625 8.29169V10.7159C18.0625 11.8992 19.0192 12.8584 20.2025 12.8617H22.4984M17.9067 18.7988H13.4067M16.2026 15.6717H13.4059M18.2814 8.30152H12.7373C11.0039 8.29485 9.58311 9.67652 9.54227 11.409V20.3365C9.50394 22.0974 10.8998 23.5565 12.6606 23.5957C12.6864 23.5957 12.7114 23.5965 12.7373 23.5957H19.3948C21.1398 23.5249 22.5148 22.0832 22.5023 20.3365V12.6982L18.2814 8.30152Z"
                    stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="col-8 col-sm-3">
                <h5 class="heading-bold">₹{{invoice?.amountOverdue || 0}}</h5>
                <p>Amount Overdue</p>
              </div>

              <div class="col-8 col-sm-3">
                <h5 class="heading-bold">₹{{invoice?.walletBalance || 0}}</h5>
                <p>Wallet Balance</p>
              </div>
              <div class="col-4 col-sm-1 text-end">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="32" height="32" rx="4" fill="#2196F3" fill-opacity="0.08"/>
                  <path
                    d="M24.0326 17.9965H20.659C19.4203 17.9957 18.4163 16.9924 18.4155 15.7537C18.4155 14.515 19.4203 13.5118 20.659 13.511H24.0326M21.0407 15.7024H20.7809M11.8632 12.2818H16.3623M12.4566 8.5H19.6594C22.0745 8.5 24.0325 10.4579 24.0325 12.8731V18.8539C24.0325 21.269 22.0745 23.227 19.6594 23.227H12.4566C10.0414 23.227 8.0835 21.269 8.0835 18.8539V12.8731C8.0835 10.4579 10.0414 8.5 12.4566 8.5Z"
                    stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <div class="box-body">
              <canvas id="invoicesOverdue" height="70"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-md-7 col-lg-5 mb-4">
      <h2>Shipments</h2>
      <div class="row">
        <div class="col-md-6 mb-2 mb-md-0 " style="position: relative; ">
          <div class="box " (click)="navigateToShipment()">
            <h1 style="z-index: 1100; ">{{shipments?.submittedCount || 0}}
              <small>New</small>
            </h1>
            <div class="widget-graph ">
              <canvas id="newShipmentChart"></canvas>
            </div>
          </div>
        </div>
        <div class="col-md-6 " style="position: relative; ">
          <div class="box " (click)="navigateToShipment()">
            <h1 style="z-index: 1100; ">{{shipments?.readyToShipCount || 0}}
              <small>Ready To Ship (Today)</small>
            </h1>
            <div class="widget-graph ">
              <canvas id="readyShipmentChart"></canvas>
            </div>
          </div>
        </div>
        <div class="col-md-6 mt-2" style="position: relative; ">
          <div class="box " (click)="navigateToShipment()">
            <h1 style="z-index: 1100;">{{shipments?.shippedCount || 0}}
              <small>Shipped (Today)</small>
            </h1>
            <div class="widget-graph ">
              <canvas id="shippedShipmentChart"></canvas>
            </div>
          </div>
        </div>
        <div class="col-md-6 mt-2 " style="position: relative; ">
          <div class="box " (click)="navigateToShipment()">
            <h1 style="z-index: 1100; ">{{shipments?.completedCount || 0}}
              <small>completed (Today)</small>
            </h1>
            <div class="widget-graph ">
              <canvas id="completedShipmentChart"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <h2 *ngIf="!accountOwner">Customer</h2>
  <div class="row mb-4" *ngIf="!accountOwner">
    <div class="col-md-6 mb-2 mb-md-0">
      <div class="box pb-0">
        <h2 class="color-3 text-capitalize mb-3">Top 5 customer (by revenue)</h2>
        <div class="table-3">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Revenue</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let customer of customersByRevenue">
              <td>{{customer.customerName}}</td>
              <td>{{customer.invoiceAmount}}</td>
            </tr>
            <tr *ngIf="!customersByRevenue">
              <td colspan="2" class="text-center">No data available</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="box pb-0">
        <h2 class="color-3 text-capitalize mb-3">Top 5 customer (by # orders)</h2>
        <div class="table-3">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Orders Count</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let customer of customersByOrder">
              <td>{{customer.customerName}}</td>
              <td>{{customer.ordersCount}}</td>
            </tr>
            <tr *ngIf="!customersByOrder">
              <td colspan="2" class="text-center">No data available</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

<!--
  <div class="row mb-4">
    <div class="col-md-6 mb-2 mb-md-0">
      <div class="box pb-0">
        <h2 class="color-3 text-capitalize mb-3">Shipments by Carrier</h2>
        <div class="table-3">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">Carrier</th>
              <th scope="col">Quantity</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Gati</td>
              <td>946</td>
            </tr>
            <tr>
              <td>Dotzot</td>
              <td>23</td>
            </tr>
            <tr>
              <td>Shippigo</td>
              <td>695</td>
            </tr>
            <tr>
              <td>Vamaship</td>
              <td>156</td>
            </tr>
            &lt;!&ndash;<tr *ngIf="!customersByRevenue">
              <td colspan="2" class="text-center">No data available</td>
            </tr>&ndash;&gt;
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="box pb-0">
                <h2 class="color-3 text-capitalize mb-3">Order by Store</h2>
        <div class="table-3">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">Store</th>
              <th scope="col">Quantity</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>WooCommerce</td>
              <td>96</td>
            </tr>
            <tr>
              <td>Magento</td>
              <td>123</td>
            </tr>
            <tr>
              <td>Shopify</td>
              <td>65</td>
            </tr>
            <tr>
              <td>Amazon</td>
              <td>16</td>
            </tr>
            &lt;!&ndash;<tr *ngIf="!customersByRevenue">
              <td colspan="2" class="text-center">No data available</td>
            </tr>&ndash;&gt;
            </tbody>
          </table>
          </div>
      </div>
    </div>
  </div>
-->

  <div class="row mt-4">
    <div class="col-md-6 mb-2 mb-md-0">
      <div class="box pb-0">
        <h2 class="color-3 text-capitalize mb-3">Shipments by Carrier</h2>
        <div class="table-3">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">Carrier</th>
              <th scope="col">Quantity</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let co of shipmentByCarrierInfo">
              <td>
                {{(co.carrierCode == 'SD' ? 'Shift' :
                (co.carrierCode == 'DL' ? 'Delhivery' :
                (co.carrierCode == 'GT' ? 'Gati' :
                (co.carrierCode == 'DZ' ? 'Dotzot' :
                (co.carrierCode == 'RD' ? 'Rapid Delivery' :
                (co.carrierCode == 'SF' ? 'Shadow Fax' :
                (co.carrierCode == 'BD' ? 'Blue Dart' :
                (co.carrierCode == 'PR' ? 'Pickrr' :
                (co.carrierCode == 'SY' ? 'Ship Yaari' :
                (co.carrierCode == 'DE' ? 'Delhivery' :
                (co.carrierCode == 'SG' ? 'Shippigo' :
                (co.carrierCode == 'VS' ? 'Vamaship' :
                (co.carrierCode == 'DN' ? 'Dunzo' :
                (co.carrierCode == 'XB' ? 'Xpressbees' :
                (co.carrierCode == 'KE' ? 'Kerry Express' :
                (co.carrierCode == 'FE' ? 'FedEx' : co.carrierCode))))))))))))))))}}
              </td>
              <td>{{co.quantity}}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr *ngIf="shipmentByCarrierInfo?.length===0|| !shipmentByCarrierInfo?.length">
              <td colspan="2" class="text-center">No matching records found</td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="box pb-0">
        <h2 class="color-3 text-capitalize mb-3">Order by Store</h2>
        <div class="table-3">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">Store</th>
              <th scope="col">Quantity</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let st of storeInfo">
              <td>{{st.storeType}}</td>
              <td>{{st.quantity}}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr *ngIf="storeInfo?.length===0|| !storeInfo?.length">
              <td colspan="2" class="text-center">No matching records found</td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div><br>

  <div class="row" style="height:250px">
    <div class="col-md-6">
      <div class="box me-1 col rounded-sm">
        <h2 class="color-3 text-capitalize mb-3">Top 5 Products</h2>

        <div class="col">
          <div class="row" *ngFor="let product of topFiveProducts">
            <div class="col-3">
              <label class="textminwid" ngxClipboard [cbContent]="product.productName"
                     ngbTooltip="{{product.productName | titlecase}}">{{product.productName}}</label>
            </div>
            <div class="col-md-7">
              <div class="progress"style="height:10px">
                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" [style.width.%]= 'product.percentage'
                >
                </div>
              </div>
            </div>
            <div class="col-md-2 progressBar">
              <span>{{product.percentage}} % </span>
            </div>
          </div>

          <!--         <div class="row">
                     <div class="col-md-3">
                       <label>Mobiles</label>
                     </div>
                     <div class="col-md-7">
                       <div class="progress"style="height:10px">
                         <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:40%">
                         </div>
                       </div>
                     </div>
                     <div class="col-md-2 progressBar">
                       <span>40%</span>
                     </div>
                   </div>
                   <div class="row">
                     <div class="col-md-3">
                       <label>Doll Clips</label>
                     </div>
                     <div class="col-md-7">
                       <div class="progress"style="height:10px">
                         <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:50%">
                         </div>
                       </div>
                     </div>
                     <div class="col-md-2 progressBar">
                       <span>50%</span>
                     </div>
                   </div>
                   <div class="row">
                     <div class="col-md-3">
                       <label>Shirt</label>
                     </div>
                     <div class="col-md-7">
                       <div class="progress" style="height:10px">
                         <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:40%">
                         </div>
                       </div>
                     </div>
                     <div class="col-md-2 progressBar">
                       <span>40%</span>
                     </div>
                   </div>
                   <div class="row">
                     <div class="col-md-3">
                       <label>LapTop</label>
                     </div>
                     <div class="col-md-7">
                       <div class="progress" style="height:10px">
                         <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:50%">
                         </div>
                       </div>
                     </div>
                     <div class="col-md-2 progressBar">
                       <span>50%</span>
                     </div>
                   </div>-->
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="box me-1 col rounded-sm">
        <h2 class="color-3 text-capitalize mb-3">Top 5 Locations</h2>

        <div class="col">
          <div class="row" *ngFor="let location of topFiveLocation">
            <div class="col-md-3">
              <label>{{location.city}}</label>
            </div>
            <div class="col-md-7">
              <div class="progress"style="height:10px">
                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" [style.width.%]= 'location.noOfOrders'>
                </div>
              </div>
            </div>
            <div class="col-md-2 progressBar">
              <span>{{location.noOfOrders}} %</span>
            </div>
          </div>
          <!--          <div class="row">
                      <div class="col-md-3">
                        <label>Guntur</label>
                      </div>
                      <div class="col-md-7">
                        <div class="progress"style="height:10px">
                          <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:60%">
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 progressBar">
                        <span>63%</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <label>Chennai</label>
                      </div>
                      <div class="col-md-7">
                        <div class="progress"style="height:10px">
                          <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:70%">
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 progressBar">
                        <span>70%</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <label>Bangalore</label>
                      </div>
                      <div class="col-md-7">
                        <div class="progress" style="height:10px">
                          <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:80%">
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 progressBar">
                        <span>80%</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <label>Mumbai</label>
                      </div>
                      <div class="col-md-7">
                        <div class="progress" style="height:10px">
                          <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:20%">
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 progressBar">
                        <span>20%</span>
                      </div>
                    </div>-->
        </div>
      </div>
    </div>
  </div>
<!--

  <div class="row mb-4">
    <div class="col-md-6 mb-2 mb-md-0">
      <div class="box pb-0">
        <h2 class="color-3 text-capitalize mb-3">Top 5 Customer (by revenue)</h2>
        <div class="table-3">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Revenue</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>pravallika</td>
              <td>$825</td>
            </tr>
            <tr>
              <td>Shiva</td>
              <td>$23</td>
            </tr>
            <tr>
              <td>sandeep</td>
              <td>$695</td>
            </tr>
            <tr>
              <td>Sharathe</td>
              <td>$156</td>
            </tr>
            &lt;!&ndash;<tr *ngIf="!customersByRevenue">
              <td colspan="2" class="text-center">No data available</td>
            </tr>&ndash;&gt;
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="box pb-0">
        <h2 class="color-3 text-capitalize mb-3">Top 5 Customer (by #orders)</h2>
        <div class="table-3">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Orders Count</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>pravallika</td>
              <td>25</td>
            </tr>
            <tr>
              <td>Shiva</td>
              <td>223</td>
            </tr>
            <tr>
              <td>sandeep</td>
              <td>5</td>
            </tr>
            <tr>
              <td>Sharathe</td>
              <td>156</td>
            </tr>
            &lt;!&ndash;<tr *ngIf="!customersByRevenue">
              <td colspan="2" class="text-center">No data available</td>
            </tr>&ndash;&gt;
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="row" style="height:250px">
    <div class="col-md-6">
      <div class="box me-1 col rounded-sm">
        <h2 class="color-3 text-capitalize mb-3">Top 5 Products</h2>

        <div class="col">
          <div class="row" *ngFor="let product of topFiveProducts">
            <div class="col-3">
              <label class="textminwid" ngxClipboard [cbContent]="product.productName"
                     ngbTooltip="{{product.productName | titlecase}}">{{product.productName}}</label>
            </div>
            <div class="col-md-7">
              <div class="progress"style="height:10px">
                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" [style.width.%]= 'product.percentage'
                >
                </div>
              </div>
            </div>
            <div class="col-md-2 progressBar">
              <span>{{product.percentage}} % </span>
            </div>
          </div>

          &lt;!&ndash;         <div class="row">
                     <div class="col-md-3">
                       <label>Mobiles</label>
                     </div>
                     <div class="col-md-7">
                       <div class="progress"style="height:10px">
                         <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:40%">
                         </div>
                       </div>
                     </div>
                     <div class="col-md-2 progressBar">
                       <span>40%</span>
                     </div>
                   </div>
                   <div class="row">
                     <div class="col-md-3">
                       <label>Doll Clips</label>
                     </div>
                     <div class="col-md-7">
                       <div class="progress"style="height:10px">
                         <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:50%">
                         </div>
                       </div>
                     </div>
                     <div class="col-md-2 progressBar">
                       <span>50%</span>
                     </div>
                   </div>
                   <div class="row">
                     <div class="col-md-3">
                       <label>Shirt</label>
                     </div>
                     <div class="col-md-7">
                       <div class="progress" style="height:10px">
                         <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:40%">
                         </div>
                       </div>
                     </div>
                     <div class="col-md-2 progressBar">
                       <span>40%</span>
                     </div>
                   </div>
                   <div class="row">
                     <div class="col-md-3">
                       <label>LapTop</label>
                     </div>
                     <div class="col-md-7">
                       <div class="progress" style="height:10px">
                         <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:50%">
                         </div>
                       </div>
                     </div>
                     <div class="col-md-2 progressBar">
                       <span>50%</span>
                     </div>
                   </div>&ndash;&gt;
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="box me-1 col rounded-sm">
        <h2 class="color-3 text-capitalize mb-3">Top 5 Locations</h2>

        <div class="col">
          <div class="row">
            <div class="col-md-3">
              <label>Hyderabad</label>
            </div>
            <div class="col-md-7">
              <div class="progress"style="height:10px">
                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:30%">
                </div>
              </div>
            </div>
            <div class="col-md-2 progressBar">
              <span>30%</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label>Guntur</label>
            </div>
            <div class="col-md-7">
              <div class="progress"style="height:10px">
                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:60%">
                </div>
              </div>
            </div>
            <div class="col-md-2 progressBar">
              <span>63%</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label>Chennai</label>
            </div>
            <div class="col-md-7">
              <div class="progress"style="height:10px">
                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:70%">
                </div>
              </div>
            </div>
            <div class="col-md-2 progressBar">
              <span>70%</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label>Bangalore</label>
            </div>
            <div class="col-md-7">
              <div class="progress" style="height:10px">
                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:80%">
                </div>
              </div>
            </div>
            <div class="col-md-2 progressBar">
              <span>80%</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label>Mumbai</label>
            </div>
            <div class="col-md-7">
              <div class="progress" style="height:10px">
                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:20%">
                </div>
              </div>
            </div>
            <div class="col-md-2 progressBar">
              <span>20%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

-->


</section>
